import { faLocationDot, faUserGroup } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEvent } from 'hooks/events';
import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom';
import 'stylesheets/EventsStyles/EventInfo.css'
import SpinnerLoading from '../Spiners';
const EventInfo = () => {
    const { id } = useParams();
    const { event, isLoading: eventLoading } = useEvent(id);

    return (
        <div className='event-info-container'>
            {
                eventLoading ? <SpinnerLoading />
                    :
                    <>
                        <img className='banner' src={event?.banner} alt="" />
                        <p className='date'>{event?.date}</p>
                        <h1 className='title'>{event?.title}</h1>
                        <div className='event-footer'>
                            <FontAwesomeIcon className='icon' icon={faLocationDot} />
                            <p>{event?.location}</p>
                        </div>
                        <div className='info-header'>
                            <div className='organizer-info'>
                                <img src={event?.organizer[1]} alt="" />
                                <div className='text'>
                                    <p className='organizer-name'>{event?.organizer[0]}</p>
                                    <p>Organizer</p>
                                </div>
                            </div>
                            <div className="attending-people">
                                <FontAwesomeIcon className='icon' icon={faUserGroup} />
                                <p>{event?.people}</p>
                            </div>

                        </div>
                        <a href='https://docs.google.com/forms/d/e/1FAIpQLScyagFFBvh8NGEDIRhH4d8Mu7tnQhB_ICxeX4VBqOODgf6rFA/viewform?usp=sharing' target='__blank'>Register now</a>
                        <div className='event-text-info'>
                            {event?.description.split('<br>').map((paragraph, index) => (
                                <div key={index}>
                                    <p key={index}>{paragraph}</p>
                                    <br />
                                </div>
                            ))}
                        </div>
                        <div className='sponsors-section'>
                            <h3>Sponsors:</h3>
                            <div className='sponsors-list'>
                                {event?.sponsors.map(sponsor => (
                                    <img className='sponsor' src={sponsor} key={sponsor} alt="" />
                                ))}
                            </div>
                        </div>
                    </>
            }
        </div>
    )
}

export default EventInfo